import React, { useState, useEffect } from 'react'
import axios from 'axios';
import config from '../../config';
import { Button, Row, Col, ListGroup } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import PdfViewing from '../../Magazine/PdfViewing';


export default function ReportsView() {
  const [programmes, setProgrammes] = useState([]);
  const [selectedProgramme, setSelectedProgramme] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const resolveImageSrc = (image) => {
    if (!image) return '';
    const normalizedImage = image.replace(/\.jpe?g$/i, (match) => {
      return match.toLowerCase() === '.jpg' ? '.jpeg' : match.toLowerCase();
    });
    return normalizedImage.includes('/') ? normalizedImage : `/img/reports/${normalizedImage}`;
  };

  const getReportDate = (item) => {
    const dateValue = item.reportDate || item.updatedOn || item.createdOn || item.updatedDate || item.reportdate || item.updatedon;
    const parsed = dateValue ? new Date(dateValue) : null;
    return parsed && !Number.isNaN(parsed.valueOf()) ? parsed : new Date(0);
  };

  const groupReportsByProgramme = (reports) => {
    return reports.reduce((acc, report) => {
      const programmeName = report.prgName || report.programme || report.prgname || 'Unknown Programme';
      const group = acc.find((item) => item.name === programmeName);
      if (group) {
        group.reports.push(report);
      } else {
        acc.push({ name: programmeName, reports: [report] });
      }
      return acc;
    }, []);
  };

  useEffect(() => {
    const fetchProgrammes = async () => {
      const fetchKey = 'Reports';
      const fetchOption = 'ReportCategory';

      setLoading(true);
      setError('');

      try {
        const response = await axios.get(`${config.api.invokeURL}/website/reports?fetchKey=${fetchKey}&fetchOption=${fetchOption}`, {
          headers: {
            'x-api-key': config.api.key,
          },
        });

        const rawData = Array.isArray(response.data)
          ? response.data
          : Array.isArray(response.data?.data)
          ? response.data.data
          : [];

        const groupedProgrammes = groupReportsByProgramme(rawData);
        if (groupedProgrammes.length > 0) {
          setProgrammes(groupedProgrammes);
          setSelectedProgramme(groupedProgrammes[0]);
        }
      } catch (fetchError) {
        console.error('Failed to load reports programmes:', fetchError);
        setError('Unable to load programmes from API.');
      } finally {
        setLoading(false);
      }
    };

    fetchProgrammes();
  }, []);

  return (
    <div className='p-2'>
      {loading && (
        <div className='mb-3 text-muted'>Loading programmes...</div>
      )}
      {error && (
        <div className='mb-3 text-danger'>{error}</div>
      )}

      <Row>
        <Col md={3}>
          <h4>Programmes</h4>
          <ListGroup>
            {programmes.map((programme, index) => (
              <ListGroup.Item
                key={index}
                action
                active={selectedProgramme?.name === programme.name}
                onClick={() => setSelectedProgramme(programme)}
              >
                {programme.name}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Col>
        <Col md={9}>
          <h4>{selectedProgramme ? `${selectedProgramme.name} - Reports` : 'Reports'}</h4>
          <Row>
            <CardGroup>
              {selectedProgramme?.reports
            ?.slice()
            .sort((a, b) => getReportDate(b) - getReportDate(a))
            .map((item, index) => {
              const reportTitle = item.Title || item.title || item.reportName || item.reportID || 'Report';
              const reportDate = item.reportDate || item.updatedOn || item.createdOn || item.reportdate || item.updatedon || '';
              const reportDescription = item.desc || item.description || item.Description || '';
              return (
                <Col md={4} key={index}>
                  <Card className='m-2'>
                    <Card.Img className='img-responsive' variant="top" src={`${config.s3.imageUrl}website/reports/${item.prgID}/${item.reportID}/${item.img}`} style={{height:"250px"}} />
                    <Card.Body>
                      <Card.Title style={{height:"auto", fontFamily:"", paddingBottom:4}}>
                        <h4 className="mb-1" style={{fontWeight:600, fontSize:'1.25rem', margin:0}}>{reportTitle}</h4>
                        {reportDate && (
                          <small className="text-muted" style={{display:'block'}}>{reportDate}</small>
                        )}
                      </Card.Title>
                      <Card.Text className='max-lines' style={{color:'#444', fontSize:'1rem', lineHeight:1.5, marginTop:8}}>
                        {reportDescription}
                      </Card.Text>
                    </Card.Body>
                    <Card.Footer>
                      <PdfViewing data={item} url={`${config.s3.imageUrl}website/reports/${item.prgID}/${item.reportID}/${item.pdfUrl}`} />
                    </Card.Footer>
                  </Card>
                </Col>
              );
            })}
            </CardGroup>
            {!selectedProgramme && !loading && !error && (
              <div className='text-muted p-3'>No programmes available.</div>
            )}
          </Row>
        </Col>
      </Row>
    </div>
  )
}
